import { ENTRYPOINT_FILE_ID } from '../../../../../pages/skills/Editor/constants';
import coerceToRecord from '../helpers/coerceToRecord';
import eventMatchesToolNames from '../helpers/eventMatchesToolNames';
import getStringValue from '../helpers/getStringValue';
import type {
    BuildNavigateToCreatedSkillSubscriptionParams,
    ChatEffectSubscription,
} from '../types';

const CREATE_SKILL_TOOL_NAMES = ['create_skill'];

const buildNavigateToCreatedSkillSubscription = (
    _params: BuildNavigateToCreatedSkillSubscriptionParams
): ChatEffectSubscription => {
    return {
        id: 'navigate-to-created-skill',
        routePattern: '*',
        eventType: 'TOOL_CALL_RESULT',
        filter: ({ event, routeParams }) => {
            if (!eventMatchesToolNames({ event, toolNames: CREATE_SKILL_TOOL_NAMES })) {
                return false;
            }

            const result = coerceToRecord({ value: event.result });
            const skill = coerceToRecord({ value: result.skill });
            const skillId = getStringValue({ value: skill.id });
            const agentId = routeParams.agentId || '';
            return skillId !== '' && agentId !== '';
        },
        action: ({ event, navigate, queryClient, routeParams }) => {
            const result = coerceToRecord({ value: event.result });
            const skill = coerceToRecord({ value: result.skill });
            const skillId = getStringValue({ value: skill.id });
            const agentId = routeParams.agentId as string;

            queryClient.invalidateQueries(['skills']);
            queryClient.invalidateQueries(['skills-search']);

            navigate(`/agents/${agentId}/skills/${skillId}/file/${ENTRYPOINT_FILE_ID}`);
        },
    };
};

export default buildNavigateToCreatedSkillSubscription;
